import {
    ServerActionWidget,
    SPI,
    ActionWidget,
    ActionType,
    ClickResult,
    RuntimeServerAction,
    SubmitValue,
    ActiveRecord
} from '@kunlun/dependencies';
import { OioNotification } from '@kunlun/vue-ui-antd';


@SPI.ClassFactory(
    ActionWidget.Token({
        actionType: ActionType.Server,
        name: 'confirmedSettlementBill',
        model: [
            'deli.aries.merchant.DeliAriesMerchantSettlementBill',
            'deli.aries.merchant.DeliAriesMerchantDisLetterBill'
        ]
    })
)
export class confirmSettlementWidget extends ServerActionWidget {
    protected executeAction(action: RuntimeServerAction, submitValue: SubmitValue): Promise<ClickResult> {
        const submitValueCopy = { ...submitValue }
        submitValueCopy.records = this.activeRecords?.[0] ?? {}
        return super.executeAction(action, submitValueCopy);
    }

    protected clickActionAfter(result: ClickResult): Promise<ClickResult> {
        const obj = {
            signUrl:null
        };
        Object.assign(obj, result);
        if(obj.signUrl){
            window.open(obj.signUrl)
        }
        return super.clickActionAfter(result);
    }
}
